const ENV = {
  local: {
    // 开发环境使用空字符串，让请求走 vue.config.js 中的代理配置
    // 这样请求会从 http://localhost:8080 代理到 http://localhost:8100
    // 避免跨域问题和 403 错误
    BASE_URL: '' // 使用相对路径，走代理
  },
  development: {
    // 开发环境使用空字符串，走代理配置
    BASE_URL: '' // 使用相对路径，走代理
  },
  testing: {
    BASE_URL: 'http://testing.api.example.com' // 测试环境接口地址
  },
  production: {
    BASE_URL: 'https://api.jzcomic.com' // 生产环境接口地址
  }
}

// 根据 `process.env.NODE_ENV` 返回对应环境的配置
const currentEnv = process.env.NODE_ENV || 'local'

// 确保返回的配置对象存在，并且 BASE_URL 有默认值
const envConfig = ENV[currentEnv] || ENV.local
if (!envConfig || envConfig.BASE_URL === undefined) {
  console.warn(`环境配置 ${currentEnv} 不存在或 BASE_URL 未定义，使用默认配置`)
}

// 确保 BASE_URL 始终有值（至少是空字符串）
const finalConfig = {
  BASE_URL: (envConfig && envConfig.BASE_URL !== undefined) ? envConfig.BASE_URL : ''
}

export default finalConfig
